import React from 'react';
import { Sparkles } from 'lucide-react';

export default function AdvancedModeWorkspace({ search }) {
  return (
    <div className="flex-1 flex items-center justify-center bg-white dark:bg-gray-900">
      <div className="max-w-md text-center px-6">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gray-100 dark:bg-gray-800 mb-4">
          <Sparkles className="w-5 h-5 text-gray-400" />
        </div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">
          Advanced mode is coming soon
        </h2>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {search.name} is set to advanced mode. The classic filter-builder UI is on the way — for now, switch back to simple mode to keep working.
        </p>
      </div>
    </div>
  );
}
